import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { constants, snowplow } from 'common/helpers'
import actions from 'redux/actions'
import { FormattedMessage } from 'sb-react-intl'

import ConfirmModal from 'components/modal/ConfirmModal/ConfirmModal'

import messages from './messages'


const placement = 'need unpause popup'

export default class NeedUnpauseModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  }

  static defaultProps = {
    name: constants.modals.limitedEditionProducts.NeedUnpause,
    title: messages.title,
  }

  handleUnpause = () => {
    snowplow.track(constants.snowplowEvents.unpauseClick, { placement }, false)

    this.close()
    actions.models.subscription.unpause({ placement })
      .then(
        () => actions.models.queue.resolveAllPostponedLimitedItems(),
        () => actions.models.queue.removeAllPostponedLimitedItems()
      )
  }

  onCancel = () => {
    const { data: { onCancel } } = this.props

    if (typeof onCancel === 'function') {
      onCancel()
    }

    this.close()
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title } = this.props

    return (
      <ConfirmModal
        name={name}
        title={title}
        id={name}
        confirmTitle={messages.confirmButton}
        cancelTitle={messages.cancelButton}
        onConfirm={this.handleUnpause}
        onCancel={this.onCancel}
        withTextCancel
      >
        <FormattedMessage {...messages.text} />
      </ConfirmModal>
    )
  }
}
